export default __webpack_public_path__ + "assets/3d904770a8e1aae49dea55f53f6540cd.png";